'use strict';

var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

var Multiaddr = require('multiaddr');

module.exports = configure(function (api) {
  /**
   * @type {import('..').Implements<typeof import('ipfs-core/src/components/bootstrap/add')>}
   */
  function add(_x) {
    return _add.apply(this, arguments);
  }

  function _add() {
    _add = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(addr) {
      var options,
          res,
          _ref,
          Peers,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return api.post('bootstrap/add', {
                timeout: options.timeout,
                signal: options.signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: addr
                }, options)),
                headers: options.headers
              });

            case 3:
              res = _context.sent;
              _context.next = 6;
              return res.json();

            case 6:
              _ref = _context.sent;
              Peers = _ref.Peers;
              return _context.abrupt("return", {
                Peers: Peers.map(function (ma) {
                  return new Multiaddr(ma);
                })
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _add.apply(this, arguments);
  }

  return add;
});